// src/utils/authRoles.js

export function isAdmin() {
  const userInfo = JSON.parse(localStorage.getItem('user-info'));
  return userInfo && !userInfo.doctor; // If "doctor" key is not present, user is admin
}

export function isDoctor() {
  const userInfo = JSON.parse(localStorage.getItem('user-info'));
  return userInfo && !!userInfo.doctor; // If "doctor" key exists, user is a doctor
}
